import React, { useEffect, useRef } from "react";
import { useForm } from 'react-hook-form';

// components
import {
    Card,
    CardHeader,
    CardBody,
    Container,
    Row,
    Col,
    FormGroup,
    Input,
    Button,
    Spinner
} from "reactstrap";
import Select from 'react-select'
import NumberFormat from 'react-number-format';
import InputImage from '../../../components/Inputs/InputImage.jsx';
import moment from "moment";

// style
import "../../../assets/css/loading.css";

// helpers
import { InputPLACA } from "../../../helpers/mask.js";
import { formateDateApi, transformValueFormatedtoFloat } from "../../../helpers/formats.js";

// services
import { showMessage } from "../../../services/message.js";
import { api_GET, api_POST, api_PUT } from "../../../services/api_service.js";
import { getSessionCookie } from "../../../services/session.js";

export default function VeiculosForm({ history, handleReturn, item }) {
    const session = getSessionCookie();

    const { register, handleSubmit, errors, setError, setValue, clearErrors } = useForm({ mode: "onBlur" });

    const [showLoading, setshowLoading] = React.useState(false);

    const [optionsConcessionaria, setOptionsConcessionaria] = React.useState([]);
    const [concessionaria, setConcessionaria] = React.useState("");
    const loadOptionsConcessionaria = () => {
        api_GET(`concessionaria`).then(result => {
            if (result.status !== 200) {
                showMessage("Aviso", result.message, 'error', null);
            }
            else {
                setOptionsConcessionaria(result.data);
                if (session.concessionariaId != null)
                    setConcessionaria(result.data.filter(f => f.concessionariaId == session.concessionariaId)[0])
            }
        });
    }
    const handleConcessionaria = value => {
        setConcessionaria(value);
        clearErrors("concessionaria");

        setModalidadesColeta([]);
        loadOptionsModalidadesColeta(value.concessionariaId);
    }

    const [placa, setPlaca] = React.useState("");
    const handlePlaca = (event) => {
        setPlaca(event.target.value);
        clearErrors("placa");
    }

    const [optionsAno, setoptionsAno] = React.useState([]);
    const loadOptionsAno = () => {
        let lista = [];

        for (var i = moment().year(); i >= 1970; i--)
            lista.push({ label: i, value: i });

        setoptionsAno(lista);
    }

    const optionsCategoria = [
        { value: 'Veículo', label: 'Veículo' },
        { value: 'Equip. Execução', label: 'Equip. Execução' },
    ]
    const [categoria, setCategoria] = React.useState("");
    const handleCategoria = (value) => {
        setCategoria(value);
        clearErrors("categoria");
    }

    const [anoFabricacao, setanoFabricacao] = React.useState("");
    const handleAnoFabricacao = (value) => {
        setanoFabricacao(value);
        clearErrors("ano_fabricacao")
    }

    const [anoImplemento, setanoImplemento] = React.useState("");
    const handleAnoImplemento = (value) => {
        setanoImplemento(value);
        clearErrors("ano_fabricacao_implemento");
    }

    const [capacidade, setCapacidade] = React.useState("");
    const handleCapacidade = (event) => {
        setCapacidade(event.target.value);
        clearErrors("capacidade");
    }

    const [tara, setTara] = React.useState("");
    const handleTara = (event) => {
        setTara(event.target.value);
        clearErrors("tara");
    }

    const [ptb, setPTB] = React.useState("");
    const handlePTB = (event) => {
        setPTB(event.target.value);
        clearErrors("ptb");
    }

    const [volumeImplemento, setVolumeImplemento] = React.useState("");
    const handleVolumeImplemento = (event) => {
        setVolumeImplemento(event.target.value);
        clearErrors("volume_implemento");
    }

    const optionsTipoImplementoVeiculo = [
        { value: 'Caçamba Basculante', label: 'Caçamba Basculante' },
        { value: 'Carroceria Aberta', label: 'Carroceria Aberta' },
        { value: 'Poliguindaste', label: 'Poliguindaste' },
        { value: 'Roll On Roll Off', label: 'Roll On Roll Off' },  
    ]

    const optionsTipoImplementoEquipExecucao = [
        { value: 'Pá carregadeira', label: 'Pá carregadeira' },
        { value: 'Retroescavadeira', label: 'Retroescavadeira' },
        { value: 'Varredeira de praia', label: 'Varredeira de praia' },
        { value: 'Carrinho para varrição', label: 'Carrinho para varrição' },
        { value: 'Equipe padrão', label: 'Equipe padrão' },
    ]

    const [tipoImplemento, setTipoImplemento] = React.useState("");
    const handleTipoImplemento = (value) => {
        setTipoImplemento(value);
        clearErrors("tipo_implemento");
    }

    const [options_status, set_options_status] = React.useState([]);
    const [status, setStatus] = React.useState("");
    const loadOptionsStatus = () => {
        let list = [];
        if (session.perfil != "Gestor" && session.perfil != "Master") {
            if (item == null) {
                list.push({ value: "Pendente de Liberação", label: "Pendente de Liberação" });
                setStatus("Pendente de Liberação");
            }
            else
                list.push({ value: item.status, label: item.status });
        }
        else {
            list.push({ value: "Pendente de Liberação", label: "Pendente de Liberação" });
            list.push({ value: "Ativo", label: "Ativo" });
            list.push({ value: "Inativo", label: "Inativo" });
        }

        set_options_status(list);
    }
    const handleStatus = (value) => {
        setStatus(value);
        clearErrors("status");
    }

    const [optionsModalidadesColeta, setoptionsModalidadesColeta] = React.useState([]);
    const [modalidadesColeta, setModalidadesColeta] = React.useState([]);
    const loadOptionsModalidadesColeta = (concessionariaId) => {
        api_GET(`modalidadeColeta/GetByConcessionaria/${concessionariaId}`).then(result => {
            if (result.status !== 200) {
                showMessage("Aviso", result.message, 'error', null);
            }
            else {
                setoptionsModalidadesColeta(result.data);
            }
        });
    }
    const handleModalidadesColeta = event => {
        let value = event;
        let lstSelect = [];
        value.map(item => {
            lstSelect.push({
                veiculoId: item == null ? 0 : item.veiculoId,
                modalidadeColetaId: item.modalidadeColetaId
            });
        });
        setModalidadesColeta(lstSelect);
    }

    const [images, setImages] = React.useState([]);
    const handleImage = (newimage, oldimage) => {
        let _images = [];
        if (oldimage != "")
            images.map(item => {
                _images.push(item.name == oldimage ? newimage : item)
            });
        else {
            _images = images;
            _images.push(newimage);
        }

        setImages(_images);
    }

    const onSubmit = (data) => {
        if (concessionaria == "") {
            setError("concessionaria");
            return;
        }
        if (placa == "") {
            setError("placa");
            return;
        }
        if (categoria == "Veículo" && anoFabricacao == "") {
            setError("ano_fabricacao");
            return;
        }
        if (categoria == "Veículo" && tara == "") {
            setError("tara");
            return;
        }
        if (categoria == "Veículo" && ptb == "") {
            setError("ptb");
            return;
        }
        if (tipoImplemento == "") {
            setError("tipo_implemento");
            return;
        }
        if (status == "") {
            setError("status");
            return;
        }

        if (categoria == "") {
            setError("categoria");
            return;
        }

        let veiculoImagensVistoria = [];
        images.map(item => {
            veiculoImagensVistoria.push({
                imagem: item.name,
                imageBase64: item.base64
            })
        });

        let json_submit = {
            veiculoId: item == null ? 0 : item.veiculoId,
            categoria: categoria,
            concessionariaId: concessionaria.concessionariaId,
            placa: placa,
            marcaModelo: categoria == "Veículo" ? data.marcaModelo : "",
            anoFabricacao: categoria == "Veículo" ? parseInt(anoFabricacao) : "",
            cor: categoria == "Veículo" ? data.cor : "",
            proprietario: "",
            capacidade: categoria == "Veículo" ? transformValueFormatedtoFloat(capacidade) : "",
            tara: categoria == "Veículo" ? transformValueFormatedtoFloat(tara) : "",
            pesoBrutoTotal: categoria == "Veículo" ? transformValueFormatedtoFloat(ptb) : "",
            tipoImplemento: tipoImplemento,
            volumeImplemento: transformValueFormatedtoFloat(volumeImplemento),
            anoFabricacaoImplemento: anoImplemento,
            dataVistoria: formateDateApi(data.data_vistoria),
            validadeVistoria: formateDateApi(data.validade_vistoria),
            status: status,
            usuarioCadastroId: session.usuarioId,
            usuarioAtualizacaoId: session.usuarioId,
            veiculoModalidadeColeta: modalidadesColeta,
            veiculoImagemVistoria: veiculoImagensVistoria
        }

        setshowLoading(true);
        if (json_submit.veiculoId == 0) {
            api_POST('veiculo', json_submit).then(result => {
                setshowLoading(false);
                if (result.status !== 200) {
                    showMessage("Aviso", result.message, 'error', null);
                }
                else {
                    showMessage("Aviso", "Operação executada com sucesso!", 'success', function () {
                        handleReturn(result.data);
                    });
                }
            });
        }
        else {
            api_PUT('veiculo', json_submit).then(result => {
                setshowLoading(false);
                if (result.status !== 200) {
                    showMessage("Aviso", result.message, 'error', null);
                }
                else {
                    showMessage("Aviso", "Operação executada com sucesso!", 'success', function () {
                        handleReturn(result.data);
                    });
                }
            });
        }
    };

    const [disableAll, setdisableAll] = React.useState(false);

    useEffect(() => {

        loadOptionsConcessionaria();
        loadOptionsStatus();
        loadOptionsAno();
        setPlaca(item == null ? "" : item.placa);
        setanoImplemento(item == null ? "" : item.anoFabricacaoImplemento);
        setValue("proprietario", item == null ? "" : item.proprietario);
        setTipoImplemento(item == null ? "" : item.tipoImplemento);
        setVolumeImplemento(item == null ? "" : item.volumeImplemento);
        setValue("data_vistoria", item == null ? "" : formateDateApi(item.dataVistoria));
        setValue("validade_vistoria", item == null ? "" : formateDateApi(item.validadeVistoria));
        setStatus(item == null ? "" : item.status);
        setCategoria(item == null ? "" : item.categoria);
        if (item != null) {
            setStatus(item.status);
            loadOptionsModalidadesColeta(item.concessionariaId);

            setConcessionaria(item.concessionaria);

            setModalidadesColeta(item.veiculoModalidadeColeta);

            let veiculoImagensVistoria = [];
            if (item.veiculoImagemVistoria != null) {
                item.veiculoImagemVistoria.map(i => {
                    veiculoImagensVistoria.push({
                        name: i.imagem,
                        base64: null
                    });
                });
                setImages(veiculoImagensVistoria);
            }

            if (item.categoria == "Veículo") {
                {
                    setValue("marcaModelo", item == null ? "" : item.marcaModelo);
                    setValue("cor", item == null ? "" : item.cor);
                    setanoFabricacao(item == null ? "" : item.anoFabricacao);
                    setCapacidade(item == null ? "" : item.capacidade);
                    setTara(item == null ? "" : item.tara);
                    setPTB(item == null ? "" : item.pesoBrutoTotal);
                }
            }

            if (session.perfil != "Gestor" && session.perfil != "Master" && item.status != "Pendente de Liberação")
                setdisableAll(true);


        }
        else {
            loadOptionsModalidadesColeta(session.concessionariaId);
        }


    }, [item]);

    return (
        <>
            {showLoading &&
                <div className="carregandoCmp">
                    <div className="box">
                        <label style={{ marginRight: "20px" }}>Carregando...</label>
                        <Spinner size="sm" color="info" />
                    </div>
                </div>
            }
            <Row>
                <Container fluid>
                    <Card className="shadow">

                        <CardHeader className="border-0">
                            <strong> Cadastro de Recurso</strong>
                        </CardHeader>
                        <CardBody>
                            <form onSubmit={handleSubmit(onSubmit)}>
                                <Row>
                                    <Col md="4" lg="4">
                                        <FormGroup>
                                            <label className="form-control-label">
                                                * Categoria
                                            </label>
                                            <Select
                                                options={optionsCategoria}
                                                name="categoria"
                                                onChange={(e) => { handleCategoria(e.value) }}
                                                value={optionsCategoria.find(obj => obj.value === categoria)}
                                                placeholder="Selecione"
                                                isDisabled={disableAll ? "yes" : ""}
                                            />
                                            {errors.categoria && <span className="form-control-label text-danger">* Campo Obrigatório</span>}
                                        </FormGroup>
                                    </Col>
                                    {session.concessionariaId == null &&
                                        <Col md="6" lg="4" className={categoria != "Veículo" && "d-none" && categoria != "Equip. Execução" && "d-none"}>
                                            <FormGroup>
                                                <label className="form-control-label" >
                                                    * Concessionária
                                                </label>
                                                <Select
                                                    options={optionsConcessionaria}
                                                    name="concessionaria"
                                                    getOptionLabel={({ identificacao }) => identificacao}
                                                    getOptionValue={({ concessionariaId }) => concessionariaId}
                                                    onChange={(value) => { handleConcessionaria(value) }}
                                                    value={optionsConcessionaria.find(obj => obj.concessionariaId === concessionaria.concessionariaId)}
                                                    placeholder="Selecione"
                                                    isDisabled={disableAll ? "yes" : ""}
                                                />
                                                {errors.concessionaria && <span className="form-control-label text-danger">* Campo Obrigatório</span>}
                                            </FormGroup>
                                        </Col>
                                    }
                                    <Col md="6" lg="4" className={categoria != "Veículo" && "d-none" && categoria != "Equip. Execução" && "d-none"}>
                                        <FormGroup>
                                            <label className="form-control-label">
                                                * Placa/Identificação
                                            </label>
                                            {categoria == "Veículo" ?
                                                <InputPLACA
                                                    name="placa"
                                                    placeholder="Placa/Identificação"
                                                    value={placa}
                                                    onChange={handlePlaca}
                                                    inputRef={register({ required: true})}
                                                    disabled={disableAll ? "disabled" : ""}
                                                /> :
                                                <Input
                                                    name="placa"
                                                    placeholder="Placa"
                                                    value={placa}
                                                    innerRef={register({ required: true})}
                                                    onChange={handlePlaca}
                                                    disabled={disableAll ? "disabled" : ""}
                                                />
                                            }

                                            {errors.placa && <span className="form-control-label text-danger">* Campo Obrigatório</span>}
                                        </FormGroup>
                                    </Col>
                                    <Col md="6" lg="4" className={categoria != "Veículo" && "d-none"}>
                                        <FormGroup>
                                            <label className="form-control-label">
                                                * Marca/Modelo
                                            </label>
                                            <Input
                                                name="marcaModelo"
                                                placeholder="Marca/Modelo"
                                                type="text"
                                                maxLength={100}
                                                innerRef={register({ required: categoria == "Veículo" ? true : false })}
                                                disabled={disableAll ? "disabled" : ""}
                                            />
                                            {errors.marcaModelo && <span className="form-control-label text-danger">* Campo Obrigatório</span>}
                                        </FormGroup>
                                    </Col>
                                    <Col md="6" lg="3" className={categoria != "Veículo" && "d-none"}>
                                        <FormGroup>
                                            <label className="form-control-label">
                                                * Cor
                                            </label>
                                            <Input
                                                name="cor"
                                                placeholder="Cor"
                                                type="text"
                                                maxLength={20}
                                                innerRef={register({ required: categoria == "Veículo" ? true : false })}
                                                disabled={disableAll ? "disabled" : ""}
                                            />
                                            {errors.cor && <span className="form-control-label text-danger">* Campo Obrigatório</span>}
                                        </FormGroup>
                                    </Col>
                                    <Col md="6" lg="3" className={categoria != "Veículo" && "d-none"}>
                                        <FormGroup>
                                            <label className="form-control-label">
                                                * Ano Fabricação
                                            </label>
                                            <Select
                                                options={optionsAno}
                                                name="ano_fabricacao"
                                                getOptionLabel={({ label }) => label}
                                                getOptionValue={({ value }) => value}
                                                onChange={(e) => { handleAnoFabricacao(e.value) }}
                                                value={optionsAno.find(obj => obj.value === anoFabricacao)}
                                                placeholder="Selecione"
                                                isDisabled={disableAll ? "disabled" : ""}
                                            />
                                            {errors.ano_fabricacao && <span className="form-control-label text-danger">* Campo Obrigatório</span>}
                                        </FormGroup>
                                    </Col>
                                    <Col md="6" lg="3" className={categoria != "Veículo" && "d-none"}>
                                        <FormGroup>
                                            <label className="form-control-label">
                                                * PBT (TON)
                                            </label>
                                            <NumberFormat
                                                className="form-control form-control-label"
                                                name="ptb"
                                                placeholder="PTB"
                                                value={ptb}
                                                onChange={handlePTB}
                                                decimalSeparator=","
                                                decimalScale="2"
                                                maxLength={10}
                                                innerRef={register({ required: categoria == "Veículo" ? true : false })}
                                                disabled={disableAll ? "disabled" : ""}
                                            />
                                            {errors.ptb && <span className="form-control-label text-danger">* Campo Obrigatório</span>}
                                        </FormGroup>
                                    </Col>
                                    <Col md="6" lg="3" className={categoria != "Veículo" && "d-none"}>
                                        <FormGroup>
                                            <label className="form-control-label">
                                                * Capacidade (TON)
                                            </label>
                                            <NumberFormat
                                                className="form-control form-control-label"
                                                name="capacidade"
                                                placeholder="Capacidade"
                                                value={capacidade}
                                                onChange={handleCapacidade}
                                                decimalSeparator=","
                                                decimalScale="2"
                                                maxLength={10}
                                                disabled={disableAll ? "disabled" : ""}
                                            />
                                            {errors.capacidade && <span className="form-control-label text-danger">* Campo Obrigatório</span>}
                                        </FormGroup>
                                    </Col>
                                    <Col md="6" lg="3" className={categoria != "Veículo" && "d-none"}>
                                        <FormGroup>
                                            <label className="form-control-label">
                                                * Tara (TON)
                                            </label>
                                            <NumberFormat
                                                className="form-control form-control-label"
                                                name="tara"
                                                placeholder="Tara"
                                                value={tara}
                                                onChange={handleTara}
                                                decimalSeparator=","
                                                decimalScale="2"
                                                maxLength={10}
                                                disabled={disableAll ? "disabled" : ""}
                                            />
                                            {errors.tara && <span className="form-control-label text-danger">* Campo Obrigatório</span>}
                                        </FormGroup>
                                    </Col>
                                    <Col md="6" lg="3" className={categoria != "Veículo" && "d-none"}>
                                        <FormGroup>
                                            <label className="form-control-label">
                                                * Tipo de Equipamento
                                            </label>
                                            <Select
                                                options={optionsTipoImplementoVeiculo}
                                                name="tipo_implemento"
                                                getOptionLabel={({ label }) => label}
                                                getOptionValue={({ value }) => value}
                                                onChange={(e) => { handleTipoImplemento(e.value) }}
                                                value={optionsTipoImplementoVeiculo.find(obj => obj.value === tipoImplemento)}
                                                placeholder="Selecione"
                                                isDisabled={disableAll ? "yes" : ""}
                                            />
                                            {errors.tipo_implemento && <span className="form-control-label text-danger">* Campo Obrigatório</span>}
                                        </FormGroup>
                                    </Col>
                                    <Col md="6" lg="3" className={categoria != "Equip. Execução" && "d-none"}>
                                        <FormGroup>
                                            <label className="form-control-label">
                                                * Tipo de Equipamento
                                            </label>
                                            <Select
                                                options={optionsTipoImplementoEquipExecucao}
                                                name="tipo_implemento"
                                                getOptionLabel={({ label }) => label}
                                                getOptionValue={({ value }) => value}
                                                onChange={(e) => { handleTipoImplemento(e.value) }}
                                                value={optionsTipoImplementoEquipExecucao.find(obj => obj.value === tipoImplemento)}
                                                placeholder="Selecione"
                                                isDisabled={disableAll ? "yes" : ""}
                                            />
                                            {errors.tipo_implemento && <span className="form-control-label text-danger">* Campo Obrigatório</span>}
                                        </FormGroup>
                                    </Col>
                                    <Col md="6" lg="3" className={categoria != "Veículo" && "d-none" && categoria != "Equip. Execução" && "d-none"}>
                                        <FormGroup>
                                            <label className="form-control-label">
                                                Ano do Equipamento
                                            </label>
                                            <Select
                                                options={optionsAno}
                                                name="ano_fabricacao_implemento"
                                                getOptionLabel={({ label }) => label}
                                                getOptionValue={({ value }) => value}
                                                onChange={(e) => { handleAnoImplemento(e.value) }}
                                                value={optionsAno.find(obj => obj.value === anoImplemento)}
                                                placeholder="Selecione"
                                                isDisabled={disableAll ? "yes" : ""}
                                            />
                                            {errors.ano_fabricacao_implemento && <span className="form-control-label text-danger">* Campo Obrigatório</span>}
                                        </FormGroup>
                                    </Col>
                                    <Col md="6" lg="3" className={categoria != "Veículo" && "d-none" && categoria != "Equip. Execução" && "d-none"}>
                                        <FormGroup>
                                            <label className="form-control-label">
                                                Volume do Equipamento (M³)
                                            </label>
                                            <NumberFormat
                                                className="form-control form-control-label"
                                                name="volume_implemento"
                                                placeholder="Volume Implemento"
                                                value={volumeImplemento}
                                                onChange={handleVolumeImplemento}
                                                decimalSeparator=","
                                                decimalScale="2"
                                                maxLength={10}
                                                disabled={disableAll ? "disabled" : ""}
                                            />
                                            {errors.volume_implemento && <span className="form-control-label text-danger">* Campo Obrigatório</span>}
                                        </FormGroup>
                                    </Col>
                                    <Col md="6" lg="3" className={categoria != "Veículo" && "d-none" && categoria != "Equip. Execução" && "d-none"}>
                                        <FormGroup>
                                            <label className="form-control-label">
                                                * Data da Vistoria
                                            </label>
                                            <Input
                                                innerRef={register({ required: true })}
                                                name="data_vistoria"
                                                placeholder="Data"
                                                type="date"
                                                disabled={disableAll ? "disabled" : ""}
                                            />
                                            {errors.data_vistoria && <span className="form-control-label text-danger">* Campo Obrigatório</span>}
                                        </FormGroup>
                                    </Col>
                                    <Col md="6" lg="3" className={categoria != "Veículo" && "d-none" && categoria != "Equip. Execução" && "d-none"}>
                                        <FormGroup>
                                            <label className="form-control-label">
                                                * Validade da Vistoria
                                            </label>

                                            <Input
                                                innerRef={register({ required: true })}
                                                defaultValue=""
                                                name="validade_vistoria"
                                                placeholder="Validade"
                                                type="date"
                                                disabled={disableAll ? "disabled" : ""}
                                            />
                                            {errors.validade_vistoria && <span className="form-control-label text-danger">* Campo Obrigatório</span>}
                                        </FormGroup>
                                    </Col>
                                    <Col md="6" lg="3" className={categoria != "Veículo" && "d-none" && categoria != "Equip. Execução" && "d-none"}>
                                        <FormGroup>
                                            <label className="form-control-label">
                                                * Status
                                            </label>
                                            <Select
                                                options={options_status}
                                                name="status"
                                                onChange={(e) => { handleStatus(e.value) }}
                                                value={options_status.find(obj => obj.value === status)}
                                                placeholder="Selecione"
                                                isDisabled={disableAll ? "yes" : ""}
                                            />
                                            {errors.status && <span className="form-control-label text-danger">* Campo Obrigatório</span>}
                                        </FormGroup>
                                    </Col>
                                    <Col md="12" className={categoria != "Veículo" && "d-none" && categoria != "Equip. Execução" && "d-none"}>
                                        <FormGroup>
                                            <label className="form-control-label">
                                                * Modalidades de Serviço
                                            </label>
                                            <Select
                                                options={optionsModalidadesColeta}
                                                name="modalidadeColeta"
                                                getOptionLabel={({ descricao }) => descricao}
                                                getOptionValue={({ modalidadeColetaId }) => modalidadeColetaId}
                                                onChange={(value) => { handleModalidadesColeta(value || []) }}
                                                value={optionsModalidadesColeta.filter(({ modalidadeColetaId }) => modalidadesColeta.filter(f => f.modalidadeColetaId == modalidadeColetaId).length > 0)}
                                                placeholder="Selecione"
                                                isMulti="true"
                                                isDisabled={disableAll ? "yes" : ""}
                                            />
                                            {errors.modalidadeColeta && <span className="form-control-label text-danger">* Campo Obrigatório</span>}
                                        </FormGroup>
                                    </Col>
                                </Row>
                                <Row>
                                    <Col md="12" className={categoria != "Veículo" && "d-none" && categoria != "Equip. Execução" && "d-none"}>
                                        <label className="form-control-label">
                                            Imagens da Vistoria
                                        </label>
                                    </Col>
                                    <Col md="4" lg="4" xl="2" className={categoria != "Veículo" && "d-none" && categoria != "Equip. Execução" && "d-none"}>
                                        <InputImage name="file1" image={images.length < 1 ? null : images[0]} uploadImage={handleImage}></InputImage>
                                    </Col>
                                    <Col md="4" lg="4" xl="2" className={categoria != "Veículo" && "d-none" && categoria != "Equip. Execução" && "d-none"}>
                                        <InputImage name="file2" image={images.length < 2 ? null : images[1]} uploadImage={handleImage}></InputImage>
                                    </Col>
                                    <Col md="4" lg="4" xl="2" className={categoria != "Veículo" && "d-none" && categoria != "Equip. Execução" && "d-none"}>
                                        <InputImage name="file3" image={images.length < 3 ? null : images[2]} uploadImage={handleImage}></InputImage>
                                    </Col>
                                    <Col md="4" lg="4" xl="2" className={categoria != "Veículo" && "d-none" && categoria != "Equip. Execução" && "d-none"}>
                                        <InputImage name="file4" image={images.length < 4 ? null : images[3]} uploadImage={handleImage}></InputImage>
                                    </Col>
                                    <Col md="4" lg="4" xl="2" className={categoria != "Veículo" && "d-none" && categoria != "Equip. Execução" && "d-none"}>
                                        <InputImage name="file5" image={images.length < 5 ? null : images[4]} uploadImage={handleImage}></InputImage>
                                    </Col>
                                </Row>
                                <Row className="mt-4">
                                    <Col md="12" className={"text-center"}>
                                        <FormGroup>
                                            <Button color="warning" type="button" onClick={() => { handleReturn() }}>Voltar</Button>
                                            {!disableAll && <Button color="success">Salvar</Button>}
                                        </FormGroup>
                                    </Col>
                                </Row>
                            </form>
                        </CardBody>
                    </Card>
                </Container>
            </Row>
        </>
    );
}
